import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
            <span className="font-heading text-2xl font-bold text-primary-600">
              韩漫之家
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                location.pathname === '/'
                  ? 'text-primary-600'
                  : 'text-foreground-700 hover:text-primary-600'
              }`}
            >
              首页
            </Link>
            <div className="relative group">
              <button className="flex items-center gap-1 text-sm font-medium text-foreground-700 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer">
                分类浏览
                <i className="ri-arrow-down-s-line text-xs"></i>
              </button>
              <div className="absolute top-full left-1/2 -translate-x-1/2 pt-3 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200">
                <div className="bg-background-50 rounded-lg shadow-lg border border-background-200 py-2 min-w-[200px]">
                  <div className="grid grid-cols-2 gap-1 px-2">
                    {categories.map((cat) => (
                      <Link
                        key={cat.slug}
                        to={`/category/${cat.slug}`}
                        className="flex items-center gap-2 px-3 py-2 rounded-md text-sm text-foreground-700 hover:bg-primary-50 hover:text-primary-600 transition-colors duration-150 whitespace-nowrap"
                      >
                        <i className={`${cat.icon} text-base`}></i>
                        {cat.name}
                      </Link>
                    ))}
                  </div>
                </div>
              </div>
            </div>
            <Link
              to="/about"
              className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                location.pathname === '/about'
                  ? 'text-primary-600'
                  : 'text-foreground-700 hover:text-primary-600'
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <button className="w-9 h-9 flex items-center justify-center rounded-full bg-background-100 hover:bg-background-200 transition-colors duration-200 cursor-pointer" aria-label="搜索">
              <i className="ri-search-line text-foreground-600"></i>
            </button>
          </div>

          <button
            className="md:hidden w-9 h-9 flex items-center justify-center rounded-full bg-background-100 cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-foreground-700 text-lg ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      <div
        className={`md:hidden transition-all duration-300 overflow-hidden ${
          mobileOpen ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <div className="bg-background-50 border-t border-background-200 px-4 py-4 space-y-2">
          <Link
            to="/"
            className="block px-3 py-2 rounded-md text-sm font-medium text-foreground-700 hover:bg-primary-50 hover:text-primary-600 transition-colors"
          >
            首页
          </Link>
          <div className="px-3 py-2 text-sm font-medium text-foreground-500">
            分类浏览
          </div>
          <div className="grid grid-cols-2 gap-1">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="flex items-center gap-2 px-3 py-2 rounded-md text-sm text-foreground-700 hover:bg-primary-50 hover:text-primary-600 transition-colors"
              >
                <i className={`${cat.icon} text-base`}></i>
                {cat.name}
              </Link>
            ))}
          </div>
          <Link
            to="/about"
            className="block px-3 py-2 rounded-md text-sm font-medium text-foreground-700 hover:bg-primary-50 hover:text-primary-600 transition-colors"
          >
            关于我们
          </Link>
        </div>
      </div>
    </nav>
  );
}